import { render } from "./myfoot.vue?vue&type=template&id=0ed0e96f&scoped=true"
const script = {}

import "./myfoot.vue?vue&type=style&index=0&id=0ed0e96f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed0e96f"]])

export default __exports__